import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useTranslation } from 'react-i18next';
import { buildIdArticlePath } from '../../../lib/utils/newsroom';
import { SUPPORTED_LANGUAGES } from '../../constants';
import PublicationsPage from '../PublicationsPage';

export const GET_PRESS_RELEASES = gql`
  query Articles {
    pressReleases {
      date
      headline
      locales {
        fr {
          headline
        }
      }
      legacyId
      title
    }
  }
`;

function PressReleasesPage() {
  const { i18n } = useTranslation();
  const { data, error, loading } = useQuery(GET_PRESS_RELEASES);

  const publications = data?.pressReleases?.map(pressRelease => ({
    ...pressRelease,
    headline: i18n.language === SUPPORTED_LANGUAGES.FRENCH && pressRelease.locales?.fr?.headline
      ? pressRelease.locales.fr.headline
      : pressRelease.headline,
    headlineLink: buildIdArticlePath(pressRelease),
  }));

  return (
    <PublicationsPage
      error={!!error}
      loading={loading}
      name="PressReleases"
      pubType="press release"
      publications={publications}
    />
  );
}

export default PressReleasesPage;
